var _rect, _rect2, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomSpiral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 680,
    viewBox: "0 0 1440 680",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 620,
    transform: "translate(0 60)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28_247",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 60,
    width: 1440,
    height: 620
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 60,
    width: 1440,
    height: 620,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28_247)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_28_247",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -533,
    y: -461,
    width: 1372,
    height: 1372
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 225,
    r: 685.5,
    fill: "url(#paint0_radial_28_247)",
    stroke: "#FF9240"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_28_247)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 151.877,
    cy: 225,
    r: 44.41,
    stroke: "#FF9240"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.877,
    cy: 225,
    r: 111.775,
    stroke: "#FF9240"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.877,
    cy: 225,
    r: 179.14,
    stroke: "#FF9240"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.877,
    cy: 225,
    r: 246.505,
    stroke: "#FF9240"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.877,
    cy: 225,
    r: 313.87,
    stroke: "#FF9240"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.877,
    cy: 225,
    r: 381.235,
    stroke: "#FF9240"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.877,
    cy: 225,
    r: 448.6,
    stroke: "#FF9240"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.877,
    cy: 225,
    r: 515.965,
    stroke: "#FF9240"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.877,
    cy: 225,
    r: 583.33,
    stroke: "#FF9240"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.877,
    cy: 225,
    r: 628.24,
    stroke: "#FF9240"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_28_247",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(153 225) rotate(90) scale(686)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.02
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomSpiral);
export default __webpack_public_path__ + "static/media/BottomSpiral.0fdb51d3fa671bb3c63515246511f3a5.svg";
export { ForwardRef as ReactComponent };